exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-9fe5d706]{scroll-behavior:smooth}", ""]);

// exports
